import React from 'react'

function ResumeInfo() {
  return (
    <div>ResumeInfo</div>
  )
}

export default ResumeInfo